const TRENDING_API_MOVIES = "https://api.themoviedb.org/3/trending/movie/day?api_key=d7eb245562d608898cbbab8c823d0259";

const TRENDING_API_MOVIES_BY_WEEK = "https://api.themoviedb.org/3/trending/movie/week?api_key=d7eb245562d608898cbbab8c823d0259";

const TRENDING_API_TVSHOWS_BY_WEEK = "https://api.themoviedb.org/3/trending/tv/week?api_key=d7eb245562d608898cbbab8c823d0259";

const TRENDING_API_TVSHOWS = "https://api.themoviedb.org/3/trending/tv/day?api_key=d7eb245562d608898cbbab8c823d0259";

const SEARCH_API = "https://api.themoviedb.org/3/search/multi?api_key=d7eb245562d608898cbbab8c823d0259&language=en-US&query=";

const DEFAULT_POSTER_Path = "https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=738&q=80";

const IMAGE_API = "https://image.tmdb.org/t/p/w1280";


export default TRENDING_API_MOVIES;

export {SEARCH_API, DEFAULT_POSTER_Path, TRENDING_API_TVSHOWS, IMAGE_API,TRENDING_API_MOVIES_BY_WEEK,TRENDING_API_TVSHOWS_BY_WEEK};